<template>
	<Icon v-bind="$props">
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fal"
			data-icon="shapes"
			class="svg-inline--fa fa-shapes"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 512 512"
		>
			<path
				class="light"
				fill="currentColor"
				d="M480 272h-160c-17.62 0-32 14.38-32 32v160c0 17.62 14.38 32 32 32h160c17.62 0 32-14.38 32-32v-160C512 286.4 497.6 272 480 272zM480 464h-160v-160h160V464zM193 224h189.1c25.33 0 41.22-26.69 28.55-48.02L316.6 15.97C310.6 6.125 299.7 0 288 0s-22.55 6.125-28.55 15.97L164.5 175.1C151.8 197.3 167.7 224 193 224zM286.8 32.62C286.1 32.32 287.5 32 288 32l1.037 .3027L382.1 192L191.1 192.3L286.8 32.62zM128 256c-70.75 0-128 57.25-128 128s57.25 128 128 128s128-57.25 128-128S198.8 256 128 256zM128 480c-52.93 0-96-43.07-96-96c0-52.94 43.07-96 96-96c52.94 0 96 43.06 96 96C224 436.9 180.9 480 128 480z"
			></path>
			<path
				class="regular"
				fill="currentColor"
				d="M128 256c-70.75 0-128 57.25-128 128s57.25 128 128 128s128-57.25 128-128S198.8 256 128 256zM128 464c-44.11 0-80-35.89-80-80c0-44.11 35.89-80 80-80c44.11 0 80 35.89 80 80C208 428.1 172.1 464 128 464zM193 224h189.1c25.33 0 41.22-26.69 28.55-48.02L316.6 15.97C310.6 6.125 299.7 0 288 0s-22.55 6.125-28.55 15.97L164.5 175.1C151.8 197.3 167.7 224 193 224zM288 61.9L355.7 176H220.3L288 61.9zM480 272h-160c-17.62 0-32 14.38-32 32v160c0 17.62 14.38 32 32 32h160c17.62 0 32-14.38 32-32v-160C512 286.4 497.6 272 480 272zM464 448h-128v-128h128V448z"
			></path>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'ShapesIcon',
	components: { Icon },
	props,
}
</script>
